/**
 * Feature 104: single source for Care Concierge Calendly configuration.
 *
 * `||` (not `??`) + trim so a missing OR blank env value both fall back — an
 * empty string would otherwise yield a blank Calendly iframe src.
 *
 * The free 15-minute tier was removed from the care-seeker chooser
 * (2026-08-24 Kirkland call): the free option cannibalized the paid
 * consultation. The free call is now the "service coordination call"
 * (Feature 137), whose link lives with its button in
 * shared/components/ServiceCoordinationCallButton.tsx.
 */
export type ConsultationTier = '60min';

const fromEnv = (value: string | undefined, fallback: string) => value?.trim() || fallback;

export const CONCIERGE_CALENDLY_URLS: Record<ConsultationTier, string> = {
  '60min': fromEnv(
    import.meta.env.VITE_CARE_CONCIERGE_CALENDLY_60MIN_URL,
    'https://calendly.com/d/cxtk-3j8-9qp/bquest-care-concierge-consultation-summary-350',
  ),
};

export const CONCIERGE_CALENDLY_MODAL_COPY: Record<
  ConsultationTier,
  { title: string; description: string }
> = {
  '60min': {
    title: 'Full consultation',
    description: 'Select a time for your 60-minute Care Concierge consultation ($350)',
  },
};
